<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,11C10.72,11,10.47,11.11,10.29,11.29C10.29,11.29,9,12.59,9,12.59C9,12.59,9,8,9,8C9,7.45,8.55,7,8,7C7.45,7,7,7.45,7,8C7,8,7,12.59,7,12.59C7,12.59,5.71,11.3,5.71,11.3C5.53,11.11,5.28,11,5,11C4.45,11,4,11.45,4,12C4,12.28,4.11,12.53,4.29,12.71C4.29,12.71,7.29,15.71,7.29,15.71C7.47,15.89,7.72,16,8,16C8.28,16,8.53,15.89,8.71,15.71C8.71,15.71,11.71,12.71,11.71,12.71C11.89,12.53,12,12.28,12,12C12,11.45,11.55,11,11,11C11,11,11,11,11,11ZM12,4C11.97,4,11.93,4,11.9,4.01C11.44,1.72,9.42,0,7,0C4.24,0,2,2.24,2,5C2,5.11,2.01,5.22,2.02,5.33C0.83,5.89,0,7.1,0,8.5C0,9.91,0.84,11.11,2.03,11.67C2.2,10.17,3.46,9,5,9C5.06,9,5.13,9.02,5.19,9.02C5.07,8.7,5,8.36,5,8C5,6.34,6.34,5,8,5C9.66,5,11,6.34,11,8C11,8.36,10.93,8.7,10.81,9.02C10.87,9.02,10.94,9,11,9C12.48,9,13.7,10.07,13.95,11.47C15.17,10.79,16,9.5,16,8C16,5.79,14.21,4,12,4C12,4,12,4,12,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CloudDownload',
} as DefineComponent
</script>
